import { FeatureFlagsState } from '@/@types'

const state: FeatureFlagsState = {
  blackFridayEnabled: false,
  cyberMondayEnabled: false,
  tcsPromoEnabled: false,
  flashSaleEnabled: false,
  showB2BBanner: false,
  premiumPlusEnabled: false,
  springPromoEnabled: false,
}

export default state
